module.exports = "/images/ni.svg?25248d4b2c68d40f6db060f9fb8781bf";